import Sidebar from '@/components/Sidebar/SidebarView.vue';
import Navbar from '@/components/HomeNavBar/HomeNavBar.vue';
import InactivityModal from '@/components/InactivityTracker/InactivityTracker.vue';
import membershipMethods from './create_membership_methods';


export default {
    components: {
        Sidebar,
        Navbar,
        InactivityModal
    },

    mounted() {
        this.get_membership_types();
        this.get_billing_cycle_choices();
        this.fetch_memberships();

        $('#create_membership').on('hidden.bs.modal', () => {
            this.resetForm();
            this.errors = {};
        });
    },

    data() {
        return ({
            memberships: [],
            membership_dashboard: {},
            editing_membership_id: null,
            membership_description: '',
            membership_price: 0,
            membership_type: '',
            membership_perks: [],
            removed_membership_perks_id: [],
            billing_cycle: '',
            billing_cycle_choices: [],
            selected_membership_id: '',
            selected_manage_membership: null,
            total_paid_users: {},
            membership_types: [],
            errors: {},
            isSubmitting: false,
            membership_submit_action: '',
            isLoading: true,
            token_exists: false,
            show_membership_type_dropdown: false,
            new_perk_name: '',
        });
    },

    computed: {
        show_sidebar() {
            return this.$route?.name !== 'organisation_create_membership';
        },
        membership_dashboard_cards() {
            return [
                { label: 'Total Plans', value: this.get_membership_dashboard_value('total_count', this.memberships.length), icon: 'bi-patch-check-fill', tone: 'primary' },
                { label: 'Active', value: this.get_membership_dashboard_value('active_count'), icon: 'bi-check-circle-fill', tone: 'success' },
                { label: 'Inactive', value: this.get_membership_dashboard_value('inactive_count'), icon: 'bi-pause-circle-fill', tone: 'secondary' },
                { label: 'Membership Types', value: this.get_membership_dashboard_value('membership_type_count'), icon: 'bi-tags-fill', tone: 'info' },
                { label: 'Billing Cycles', value: this.get_membership_dashboard_value('billing_cycle_count'), icon: 'bi-arrow-repeat', tone: 'warning' },
            ];
        }
    },

    methods: membershipMethods,
}

